import { faMoneyBill1 } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { PiCircleBold } from "react-icons/pi";

const ArabicPyamentCard = ({ payment }) => {
  const today = new Date();

  let paymentExpiry = "red";
  let formattedDate = "";

  if (payment?.toLowerCase?.() === "paid") {
    paymentExpiry = "green";
    formattedDate = "PAID";
  } else {
    const paymentDate = new Date(payment);
    const diffInDays = (today - paymentDate) / (1000 * 60 * 60 * 24);
    paymentExpiry = diffInDays < 30 ? "green" : "red";
    formattedDate = paymentDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });
  }

  return (
    <div
      className={`relative overflow-hidden rounded py-5 lg:py-2 px-5 bg-gradient-to-tl from-${paymentExpiry}-300 to-${paymentExpiry}-200 drpg-shadow-lg`}
    >
      <div className="w-auto flex justify-around">
        <div className="mr-14">
          <p>Payment</p>
        </div>
        <p className="mr-2">{paymentExpiry === "green" ? "Paid" : "Due"}</p>
        <FontAwesomeIcon
          className={`text-2xl text-${paymentExpiry}-600`}
          icon={faMoneyBill1}
        />
      </div>
      <PiCircleBold className="text-9xl absolute -ml-12 opacity-10 text-inherit" />

      <div
        className={`${paymentExpiry === "red" ? "mt-2" : "mt-4"} text-center`}
      >
        {paymentExpiry === "red" && <p>Last Paid</p>}
        <p className={`text-2xl font-bold text-${paymentExpiry}-600`}>
          {formattedDate.toUpperCase()}
        </p>
      </div>
    </div>
  );
};

export default ArabicPyamentCard;
